import {addPutMethodToForm, post,} from '../utils'
import {makeFormData} from './utils'

export default host => ({
  livestreamId,
  name,
  description,
  streamId,
  startTime,
  endTime,
  videoId,
  startImageId,
  endImageId,
  fake,
  source,
  contentCreatorId,
}) =>
  post(`${host}/livestreams/${livestreamId}`, addPutMethodToForm(makeFormData({
    name,
    description,
    streamId,
    startTime,
    endTime,
    videoId,
    startImageId,
    endImageId,
    fake,
    source,
    contentCreatorId,
  })))
    .then(response => response.json())